module.exports = __webpack_public_path__ + "static/img/battle_report3.76f72a6c.png";